// extracted by mini-css-extract-plugin
export default {"tabs":"FormTabs_tabs__-9qiV","active":"FormTabs_active__HRUnz"};